import { isPromoCard } from "../promo-cards";

type MarketplaceHit = {
    objectID?: string | number;
    id?: string | number;
    __promo?: boolean;
};

export type MarketplaceSsrRoot = {
    dataset: {
        ssrPage?: string;
        ssrFirstHitId?: string;
        ssrQueryKey?: string;
    };
};

function firstVehicleHitId(hits: MarketplaceHit[]): string | null {
    const hit = hits.find((entry) => !isPromoCard(entry));
    if (!hit) {
        return null;
    }

    return String(hit.objectID ?? hit.id ?? "");
}

/**
 * True while Blade SSR grid still matches the current InstantSearch response.
 * Must stay true across subsequent renders until the query/filters diverge.
 */
export function shouldKeepMarketplaceSsrGrid(
    ssrRoot: MarketplaceSsrRoot | null | undefined,
    results: { page?: number } | null | undefined,
    hits: MarketplaceHit[],
    configQueryKey?: string | null,
    ssrAlreadyRemoved = false,
): boolean {
    if (ssrAlreadyRemoved || !ssrRoot) {
        return false;
    }

    const ssrPage = Number.parseInt(ssrRoot.dataset.ssrPage ?? "0", 10);
    const clientPage = results?.page ?? 0;
    if (clientPage !== (Number.isNaN(ssrPage) ? 0 : ssrPage)) {
        return false;
    }

    const ssrFirstId = ssrRoot.dataset.ssrFirstHitId ?? "";
    if (ssrFirstId === "") {
        return false;
    }

    const domQueryKey = ssrRoot.dataset.ssrQueryKey ?? "";
    if (domQueryKey !== "") {
        if (!configQueryKey || configQueryKey !== domQueryKey) {
            return false;
        }
    }

    return firstVehicleHitId(hits) === ssrFirstId;
}
